module.exports = __webpack_public_path__ + "media/Images/icon-business-owner-o-55e86a1a584d7e10054f37a2bdec5090.svg";